import { contractReporter } from '@/api/contractReporter';
import type { GradedViolation } from '@/types/contract';

import { useExternalStore } from './useExternalStore';

interface ContractViolations {
    violations: readonly GradedViolation[];
    dismiss: () => void;
}

/** The major violations raised on screen; empty where LOUD_SCHEMA_ERRORS is off. */
export function useContractViolations(): ContractViolations {
    const violations = useExternalStore(contractReporter);
    return { violations, dismiss: (): void => contractReporter.dismiss() };
}
